import { call, put, putResolve, select } from 'redux-saga/effects'
import createAction from 'loankeeper-common/helpers/createAction'
import { loadingActions } from 'loankeeper-common/components/hocs/LazyLoading'
import { loadClientGeneralDetails } from 'src/store/client'

import * as API from '../../../WebAPI'
import { actions, InstanceTypes } from '../constants'
import { getPermissions } from '../../../store/permissions'
import { applicationViewGeneral } from 'src/store/application'
import { collateralView } from 'src/store/collateral'
import { loanView } from 'src/store/loan'
import { accountViewBase, accountViewByPage, accountViewSTMT } from 'src/store/account'
import { accEntryViewByPage } from 'src/store/accEntry'

// const apis = {
//   [InstanceTypes.Client]: API.Client.details,
//   [InstanceTypes.Application]: API.Application.details,
//   [InstanceTypes.Collateral]: API.Collateral.details,
//   [InstanceTypes.Loan]: API.Loan.details,
//   [InstanceTypes.Account]: API.Account.details,
//   [InstanceTypes.AccountDebit]: API.Account.debitDetails,
//   [InstanceTypes.AccountCredit]: API.Account.creditDetails,
//   [InstanceTypes.Order]: API.Order.details,
//   [InstanceTypes.OrderView]: API.Order.details,
//   [InstanceTypes.AccountStatement]: API.Account.details,
// }
const apis = {
  [InstanceTypes.Client]: loadClientGeneralDetails,
  [InstanceTypes.Application]: applicationViewGeneral,
  [InstanceTypes.Collateral]: collateralView,
  [InstanceTypes.Loan]: loanView,
  [InstanceTypes.Account]: accountViewByPage,
  // [InstanceTypes.AccountDebit]: API.Account.debitDetails,
  // [InstanceTypes.AccountCredit]: API.Account.creditDetails,
  [InstanceTypes.Order]: accEntryViewByPage,
  [InstanceTypes.OrderView]: accEntryViewByPage,
  [InstanceTypes.AccountStatement]: accountViewByPage,
}

const transformParams = (params, type) => {
  switch (type) {
    case InstanceTypes.Client:
      return {
        clientId: params.ID,
        clientHash: params.hash,
        ...params,
      }
    case InstanceTypes.Application: {
      const newParams = {
        AppID: params.ID,
        HashSum_AppID_: params.hash,
        ...params,
        ...params.additionalParams,
      }

      if (!params?.additionalParams?.ID) {
        delete params.ID
      }

      delete newParams.hash
      delete newParams.additionalParams

      return newParams
    }

    case InstanceTypes.Collateral:
      return {
        CollateralID: params.ID,
        HashSum_CollateralID_: params.hash,
        page: params.page,
      }

    case InstanceTypes.Loan: {
      const newParams = {
        LoanID: params.ID,
        HashSum_LoanID_: params.hash,
        ActiveOperFlag: 1,
        ...params,
        ...params.additionalParams,
      }
      delete newParams.ID
      delete newParams.hash
      delete newParams.additionalParams
      return newParams
    }
    case InstanceTypes.Account:
    case InstanceTypes.AccountStatement: {
      const newParams = {
        AccountID: params.ID,
        HashSum_AccountID_: params.hash,
        ...params,
      }
      delete newParams.ID
      delete newParams.hash

      return newParams
    }

    case InstanceTypes.AccountDebit:
      return {
        DebitAccID: params.ID,
        HashSum_DebitAccID_: params.hash,
        ...params,
      }

    case InstanceTypes.AccountCredit:
      return {
        CreditAccID: params.ID,
        HashSum_CreditAccID_: params.hash,
        ...params,
      }

    case InstanceTypes.Order:
    case InstanceTypes.OrderView: {
      const newParams = {
        EntryID: params.ID,
        HashSum_EntryID_: params.hash,
        ...params,
      }
      delete newParams.ID
      delete newParams.hash

      return newParams
    }
  }
}

const isAllowedToFetch = (permission, permissions) => {
  if (typeof permission === 'string') {
    return permissions[permission]
  }

  if (typeof permission === 'function') {
    return permission(permissions)
  }

  return true
}

function* fetcher({ payload, meta: { type, ID, permission, callback } }) {
  try {
    if (payload.firstSwitch) loadingActions.start()

    const permissions = yield select(getPermissions)
    const isAllowed = isAllowedToFetch(permission, permissions)
    if (!isAllowed) {
      return
    }

    let dataToSendOnServer = payload

    if (payload[payload.page]) {
      dataToSendOnServer = {
        ...payload,
        ...payload[payload.page],
      }

      delete dataToSendOnServer[payload.page]
    }

    // const { Data } = yield call(apis[type], dataToSendOnServer)
    const result = yield putResolve(apis[type](transformParams(dataToSendOnServer, type)))
    if (!apis[type].fulfilled.match(result)) {
      throw { Error: { Message: result.payload, Text: result.payload } }
    }

    const { payload: Data } = result

    const action = createAction(actions.data.FETCH_SUCCESS, { page: payload.page, data: Data }, { type, ID })

    yield put(action)
  } catch (e) {
    const action = createAction(actions.data.FETCH_FAILURE, { page: payload.page, error: e.Error }, { type, ID })

    yield put(action)
  } finally {
    if (typeof loadingActions.stop === 'function') {
      loadingActions.stop()
    }
  }

  if (typeof callback === 'function') {
    callback()
  }
}

export default fetcher
